const DEFAULT_UI_LOCALES = ["en", "es", "de", "fr"];
const UNSAFE_LOCALE_PATTERN = /\.\.|[?#/\\]/;

export function resolveUiLocale(locale, extraLocales = []) {
  if (typeof locale !== "string") return null;

  const trimmedLocale = locale.trim();

  if (!trimmedLocale || UNSAFE_LOCALE_PATTERN.test(trimmedLocale)) {
    return null;
  }

  if (DEFAULT_UI_LOCALES.includes(trimmedLocale)) {
    return trimmedLocale;
  }

  const isSafeExtra =
    Array.isArray(extraLocales) &&
    extraLocales.some(
      extraLocale =>
        typeof extraLocale === "string" &&
        !UNSAFE_LOCALE_PATTERN.test(extraLocale) &&
        extraLocale === trimmedLocale
    );

  return isSafeExtra ? trimmedLocale : null;
}
